import {
  queryOptions,
  infiniteQueryOptions,
  type TQueryKey,
  type InfiniteData,
} from '@react/utils/queryHooks';

import type { IPagyPostVMProps, IPostVMProps } from '@data/view-models';

import { postApi, QK_FETCH_POST, QK_FETCH_POSTS } from '~/requests/postApi';

interface IPostsOptionsParams {
  topics?: string[];
}

export type TPostsOptions = Omit<
  ReturnType<
    typeof infiniteQueryOptions<
      IPagyPostVMProps,
      Error,
      InfiniteData<IPagyPostVMProps, unknown>,
      Array<TQueryKey | Required<IPostsOptionsParams>>,
      string
    >
  >,
  'queryFn'
>;

export function postsOptions({ topics }: IPostsOptionsParams): TPostsOptions {
  return infiniteQueryOptions({
    retry: false,
    initialPageParam: '',
    queryKey: [
      QK_FETCH_POSTS,
      {
        topics: topics || [],
      },
    ],
    queryFn: async ({ pageParam, signal }) => {
      return postApi
        .getPosts({
          signal,
          cursor: pageParam,
          topics: topics || [],
        })
        .catch(() => {
          return {
            data: [],
            metadata: {
              total: 0,
              perPage: 0,
              currentTotal: 0,
              cursor: undefined,
            },
          };
        });
    },
    getNextPageParam: (lastPage) => {
      return lastPage.metadata.cursor;
    },
  });
}

interface IPostOptionsParams {
  slug: string;
}

export type TPostOptions = Omit<
  ReturnType<
    typeof queryOptions<
      IPostVMProps,
      Error,
      IPostVMProps,
      Array<TQueryKey | IPostOptionsParams>
    >
  >,
  'queryFn'
>;

export function postOptions({ slug }: IPostOptionsParams): TPostOptions {
  return queryOptions({
    queryKey: [
      QK_FETCH_POST,
      {
        slug,
      },
    ],
    queryFn: async ({ signal }) => {
      return postApi.getPost({
        slug,
        signal,
      });
    },
  });
}
